import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Button } from 'react-bootstrap';

import { StringToInt, numberFormat } from '../../../utils';
import {
  makeGetAuth,
  makeGetCashInBank,
  makeGetDefaultAccount,
  makeGetToken,
} from '../../../lib/selector';
import { holdBankRequest } from '../../../containers/cash/actions';
import { v4 as uuidv4 } from 'uuid';
import RenderInputMask from '../../input/renderInputMask';
import { required } from '../../../utils/validation';
import { setAuth } from '../../../containers/client/actions';

class FormUnHoldBank extends Component {
  submit = (values) => {
    const { amount } = values;
    const { token, auth, defaultAccount, cashInBank, holdType } = this.props;
    console.log('FormUnHoldBank', amount);
    if (!cashInBank || !token) return;
    const _amount = StringToInt(amount.replace(',', ''));

    if (holdType === '1') {
      // gui them
      if (_amount > cashInBank.avalBal) {
        this.props.handleToast(
          'Gửi thêm tối đa: ' + numberFormat(cashInBank.avalBal, 0, '0')
        );
        return;
      }
    } else {
      if (_amount > cashInBank.holdAmt) {
        this.props.handleToast(
          'Rút tối đa: ' + numberFormat(cashInBank.holdAmt, 0, '0')
        );
        return;
      }
    }

    if (_amount > 0) {
      const uuid = uuidv4();
      const resData = {
        group: 'CORE',
        user: token.user,
        session: token.session,
        cmd: 'RequestHold',
        rqId: uuid,
        channel: 'WTS',
        type: auth.type,
        token: auth.token,
        data: {
          acntNo: defaultAccount.acntNo,
          subAcntNo: defaultAccount.subAcntNo,
          holdType: holdType,
          amount: _amount,
        },
      };

      this.props.dispatch(holdBankRequest(resData));

      this.props.reset();
    }
  };

  _handleAuthen = () => {
    this.props.dispatch(setAuth());
  };

  render() {
    const {
      amount,
      handleSubmit,
      pristine,
      submitting,
      holdType,
      cashInBank,
      auth,
    } = this.props;

    console.log(amount);

    return (
      <form
        className="form-trade d-flex flex-row justify-content-end mt-2"
        onSubmit={handleSubmit(this.submit)}
      >
        <span className="fz-14 txt-content">
          {holdType === '1' ? 'Gửi thêm' : 'Rút tiền'}
        </span>
        <Field
          name="amount"
          placeholder={`Tối đa ${
            cashInBank &&
            (holdType === '1'
              ? numberFormat(cashInBank.avalBal, 0, '0')
              : numberFormat(cashInBank.holdAmt, 0, '0'))
          }`}
          classname="form-control text-right form-input fz-14 w_125 ml-2 mr-2"
          component={RenderInputMask}
          validate={required}
        />
        {auth && auth.isVerified ? (
          <Button
            type="submit"
            disabled={pristine || submitting}
            className="fz-14 font-weight-bold"
            style={{
              backgroundColor: '#1BA0E1',
              border: 'none',
              padding: '0px 20px',
              height: '28px',
            }}
          >
            {`Rút tiền {${numberFormat(amount, 0)}} VND `}
          </Button>
        ) : (
          <Button
            variant="warning"
            className="fz-14 font-weight-bold text-white"
            onClick={() => this._handleAuthen()}
            style={{ width: '215px' }}
          >
            Xác thực
          </Button>
        )}
      </form>
    );
  }
}

FormUnHoldBank = reduxForm({
  form: 'unholdbank',
})(FormUnHoldBank);

const selector = formValueSelector('unholdbank');

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAuth = makeGetAuth();
  const getCashInBank = makeGetCashInBank();
  const getDefaultAccount = makeGetDefaultAccount();

  const mapStateToProps = (state) => {
    const { amount, content } = selector(state, 'amount', 'content');
    return {
      token: getToken(state),
      auth: getAuth(state),
      cashInBank: getCashInBank(state),
      defaultAccount: getDefaultAccount(state),
      amount,
    };
  };
  return mapStateToProps;
};

FormUnHoldBank = connect(makeMapStateToProps)(FormUnHoldBank);

export default FormUnHoldBank;
